import { render, staticRenderFns } from "./T1TopOffersPlaceholder.vue?vue&type=template&id=79f81592&scoped=true&"
var script = {}
import style0 from "./T1TopOffersPlaceholder.vue?vue&type=style&index=0&id=79f81592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f81592",
  null
  
)

export default component.exports